import type { IconProps } from '../types/IconProps.ts';
export const Clipboard: IconProps = {
    name: 'Clipboard',
    children: [
        `<path d="M8 4H6a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2" />`,
        `<rect width="8" height="4" x="8" y="2" rx="2" />`,
        `<path d="M8 10h4M8 14h8M8 18h5" />`,
    ]
};